var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-confirm-dialog',{attrs:{"show":_vm.setShow,"title":'Unlink customer(s)',"button-text":'Unlink',"button-type":'danger',"button-status":_vm.unlinking},on:{"update:show":function($event){_vm.setShow=$event},"confirm":_vm.unlink}},[_c('p',[_vm._v("Are you sure you want to unlink selected customers?")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }